import { useEffect } from "react";

const TOOLTIP_CSS = `
.inv-tip-mark{
  position:relative;display:inline-flex;align-items:center;justify-content:center;
  vertical-align:middle;margin-left:4px;flex-shrink:0;
}
.inv-tip-trigger{
  width:14px;height:14px;border-radius:50%;
  border:1px solid rgba(120,130,140,.45);
  background:#fff;color:rgba(72,82,92,.95);
  font-size:9px;font-weight:700;line-height:1;
  display:inline-flex;align-items:center;justify-content:center;
  cursor:help;padding:0;font-family:ui-sans-serif,system-ui,sans-serif;
  box-shadow:0 1px 2px rgba(16,24,20,.06);
}
.inv-tip-mark::after{
  content:attr(data-tip);
  position:absolute;bottom:calc(100% + 8px);left:50%;transform:translateX(-50%);
  background:#fff;color:#2e3a35;
  font-size:11px;font-weight:500;font-family:ui-sans-serif,system-ui,sans-serif;
  line-height:1.45;padding:10px 12px;border-radius:10px;
  white-space:pre-line;max-width:260px;min-width:140px;text-align:left;
  box-shadow:0 6px 24px rgba(16,24,20,.14);
  border:1px solid rgba(30,40,34,.08);
  pointer-events:none;opacity:0;transition:opacity .15s ease;z-index:3000;
}
.inv-tip-mark::before{
  content:'';position:absolute;bottom:calc(100% + 2px);left:50%;
  transform:translateX(-50%);
  border:6px solid transparent;border-top-color:#fff;
  filter:drop-shadow(0 1px 1px rgba(16,24,20,.06));
  pointer-events:none;opacity:0;transition:opacity .15s ease;z-index:3000;
}
.inv-tip-mark:hover::after,.inv-tip-mark:hover::before,
.inv-tip-mark:focus-visible::after,.inv-tip-mark:focus-visible::before{opacity:1;}
.inv-tip-mark.inv-tip-down::after{
  top:calc(100% + 8px);bottom:auto;
}
.inv-tip-mark.inv-tip-down::before{
  top:calc(100% + 2px);bottom:auto;
  border-top-color:transparent;border-bottom-color:#fff;
}
@media(max-width:820px){
  .inv-tip-mark::after,.inv-tip-mark::before{display:none;}
  .inv-tip-mark.inv-tip-open::after,.inv-tip-mark.inv-tip-open::before{display:block;opacity:1;}
}
`;

function useInvelpsTooltipStyles() {
  useEffect(() => {
    if (document.getElementById("inv-tooltip-css")) return;
    const s = document.createElement("style");
    s.id = "inv-tooltip-css";
    s.textContent = TOOLTIP_CSS;
    document.head.appendChild(s);
  }, []);
}

/** Tooltip hover (bulle blanche, ?) — modèle page Accueil / KPI Marché */
export default function InvelpsTipMark({ title, down = false }) {
  useInvelpsTooltipStyles();
  const text = String(title || "").trim();
  if (!text) return null;

  return (
    <span
      className={`inv-tip-mark${down ? " inv-tip-down" : ""}`}
      data-tip={text}
      tabIndex={0}
      role="button"
      aria-label={text}
      onClick={(e) => {
        if (typeof window !== "undefined" && window.matchMedia("(max-width: 820px)").matches) {
          e.stopPropagation();
          e.currentTarget.classList.toggle("inv-tip-open");
        }
      }}
      onBlur={(e) => e.currentTarget.classList.remove("inv-tip-open")}
    >
      <span className="inv-tip-trigger" aria-hidden="true">
        ?
      </span>
    </span>
  );
}

export { useInvelpsTooltipStyles };
